import map from 'lodash/map';
import get from 'lodash/get';

import env from 'utils/env';
import { track } from 'utils/segment';
import { PLAN_CODE } from './user';

export const INVITE_STATE = {
  invite_invalid: 'invalid',
  invite_expired: 'expired',
  unredeemed: 'unredeemed',
  redeemed_sale: 'redeemed-sale',
  member: 'member',
  seasonal: 'seasonal',
  expired: 'expired',
};

export const USER_TYPE = {
  redeemed: 'redeemed',
  member: 'member',
};

export const getUserType = (planCode) => {
  if (planCode === PLAN_CODE.fffsocial) return USER_TYPE.redeemed;
  if (planCode === PLAN_CODE.fffvip || planCode === PLAN_CODE.fffvipa)
    return USER_TYPE.member;
  return null;
};

const REDIRECT_URL = {
  login: `https://login.${env.hostname}`,
  createAccount: `https://${env.hostname}/create-account`,
  getTheBox: `https://${env.hostname}/get-the-box`,
  subscribe: `https://${env.hostname}/subscribe-today`,
  edit: `https://${env.hostname}/edit`,
  upgrade: `https://${env.hostname}/upgrade-confirmation`,
  reactivate: `https://${env.hostname}/reactivate-my-membership`,
  checkMyAccount: `https://${env.hostname}/my-account`,
};

export const REDIRECT_ACTION = {
  login: () => {
    window.location.href = REDIRECT_URL.login;
  },
  createAccount: (inviteCode) => {
    window.location.href = `${REDIRECT_URL.createAccount}?inviteCode=${inviteCode}`;
  },
  getTheBox: () => {
    window.location.href = REDIRECT_URL.getTheBox;
  },
  subscribe: () => {
    window.location.replace(REDIRECT_URL.subscribe);
  },
  edit: () => {
    window.location.replace(REDIRECT_URL.edit);
  },
  upgrade: () => {
    window.location.href = REDIRECT_URL.upgrade;
  },
  reactivate: (referrer) => {
    window.location.href = referrer
      ? `${REDIRECT_URL.reactivate}?referrer=${referrer}`
      : REDIRECT_URL.reactivate;
  },
  checkMyAccount: () => {
    window.location.href = REDIRECT_URL.checkMyAccount;
  },
};

export const trackInviteStarted = (trackingData, experience, ctaName) => {
  track('Invite Started', {
    ...trackingData,
    experience,
    cta_name: ctaName,
  });
};

// sort Sneak Peek products according to productIds order
export const sortPreviewProducts = (productIds, products) =>
  map(productIds, (id) => get(products, id, {}));

export const formatProduct = (product) => {
  const { productName, productBrand } = product;
  return productBrand ? `${productName} by ${productBrand}` : productName;
};
